import React from "react";
import styled, { css } from "styled-components";

import { Icon } from "src/library/components/Icon";
import { Icons } from "src/library/components/Icon/types";
import { Text } from "src/library/components/Text";

type IconSelectProps = {
  icon: Icons;
  onClick: () => void;
  label?: string;
  selected: boolean;
  iconSize?: number;
  className?: string;
};

export const IconSelect: React.FC<IconSelectProps> = ({
  icon, onClick, label, selected, className, iconSize = 40
}) => {
  return (
    <StyledSelectWrapper
      iconSize={iconSize}
      onClick={onClick}
      className={className}
    >
      <Icon
        icon={icon}
        size={iconSize}
        $fillColor="primaryLight"
        className={selected ? "icon selected" : "icon"}
      />

      {label && (
        <Text className={selected ? "label selected-label" : "label"}>
          {label}
        </Text>
      )}
    </StyledSelectWrapper>

  );
};

const StyledSelectWrapper = styled.div<{ iconSize: number }>`
  {${({ theme, iconSize }) => css`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    
    .icon{
      padding: ${theme.spacing.padding.sm};
      border-width: 1px;
      border-color: ${theme.colors.lightGrey};
      border-style: solid;
      border-radius: ${iconSize / 2}px;
    }

    .label{
      padding-top: ${theme.spacing.padding.xs};
    }

    :hover {
      .icon{
        background: ${theme.colors.lightGrey};
      }
    }
    
    .selected{
      background: ${theme.colors.lightGrey};
      border-color: ${theme.colors.primaryDark};
    }

    .selected-label{
      font-weight: ${theme.fonts.weights.bold};
    }
  `} 
`;